import { COLORS } from '../../../configs/colors';

export const StyledReactQuill = (error: boolean) => ({
  width: '100%',
  height: '100%',
  border: error ? `1px solid ${COLORS.DarkRed}` : '',
  borderRadius: 4
});